var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tableInfo" },
    [
      _c("div", { staticClass: "flex_space ts_box flex_center_align" }, [
        _c("div", { staticClass: "title" }, [_vm._t("title")], 2),
        _c("div", { staticClass: "flex_end up_box flex_center_align" }, [
          _c(
            "span",
            _vm._g(
              {
                staticClass: "upload_title flex_center_align",
                class: [{ up: _vm.up }, { disabled_file_name: _vm.disabled }],
              },
              _vm.$listeners
            ),
            [_vm._t("upload")],
            2
          ),
          _c(
            "div",
            {
              staticClass: "arrow_box flex_center_align flex_center",
              on: {
                click: function ($event) {
                  _vm.fold = !_vm.fold
                },
              },
            },
            [
              _c("svg-icon", {
                staticClass: "arrow_svg",
                class: { rote: _vm.fold },
                attrs: { "icon-class": "up_line" },
              }),
            ],
            1
          ),
        ]),
      ]),
      !_vm.fold ? [_vm._t("row")] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }